<template>
    <v-layout justify-center>
        <v-responsive width="100%" height="100%" max-width="1080" class="mx-n3 px-3">
            <list-heading title="벤더정보 관리" @input="updateItem">
                <template #add-button>
                    <manufacturing-vendor-form>
                        <template #activator="{attrs ,on}">
                            <v-btn text icon tile color="primary" class="my-n1" v-bind="attrs" v-on="on">
                                <v-icon>mdi-plus</v-icon>
                            </v-btn>
                        </template>
                    </manufacturing-vendor-form>
                </template>
            </list-heading>

            <v-data-table v-bind="{ loading, headers, items }" disable-sort disable-pagination hide-default-footer :items-per-page="-1" class="v-sheet--outlined">
                <template v-for="(header, index) in headers.filter((header) => header.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value, item }"> <span :key="index" :title="header.withTitle ? header.formatter.bind(item)(value, item) : undefined" v-html="header.formatter.bind(item)(value, item)" /> </template>
                <template #[`item.name`]="{ value, item, header }">
                    <v-list-item dense>
                        <v-list-item-avatar :color="item.color" size="12" />
                        <v-list-item-title>
                            {{ header.formatter(value) }}
                        </v-list-item-title>
                    </v-list-item>
                </template>
                <template #[`item.isActive`]="{ item }">
                    <v-switch v-model="item.isActive" class="d-inline-block ml-1 mr-n3" v-bind="attrs_switch" @change="(isActive) => update({ _id: item._id, isActive })" />
                </template>
                <template #[`item.isPrimary`]="{ item }">
                    <v-switch v-model="item.isPrimary" class="d-inline-block ml-1 mr-n3" v-bind="attrs_switch" @change="(isPrimary) => update({ _id: item._id, isPrimary })" />
                </template>
                <template #[`item.isForeign`]="{ item }">
                    <v-switch v-model="item.isForeign" class="d-inline-block ml-1 mr-n3" v-bind="attrs_switch" @change="(isForeign) => update({ _id: item._id, isForeign })" />
                </template>
                <template #[`item.actions`]="{ item }">
                    <manufacturing-vendor-form :value="item" @input="updateItem">
                        <template #activator="{attrs ,on}">
                            <v-btn small text icon tile v-bind="attrs" v-on="on">
                                <v-icon small>mdi-pencil</v-icon>
                            </v-btn>
                        </template>
                    </manufacturing-vendor-form>
                </template>
            </v-data-table>

            <v-pagination :value="page" :length="pageCount" :total-visible="11" class="mt-4 mx-4" @input="(page) => $router.push({ query: { ...$route.query, page } })"></v-pagination>
        </v-responsive>
    </v-layout>
</template>

<script>
import api from "@/api";
import { attrs_switch } from "@/assets/variables/attrs";
import { initDataTableHeaders } from "@/assets/variables/inits";
import { MANUFACTURING_VENDOR_CODES } from "@/assets/variables/constants";

import ListHeading from "@/components/console/dumb/list-heading.vue";
import ManufacturingVendorForm from "@/components/console/manufacturing/vendor/manufacturing-vendor-form.vue";

const headers = initDataTableHeaders([
    { text: "#", value: "index", width: +80, align: "right" },
    { text: "벤더", value: "code", formatter: (key) => MANUFACTURING_VENDOR_CODES[key]?.text || "-" },
    { text: "이름", value: "name", cellClass: "pa-0" },
    { text: "웹사이트", value: "site" },
    { text: "사용여부", value: "isActive", width: +80, align: "center" },
    { text: "기본벤더", value: "isPrimary", width: +80, align: "center" },
    { text: "해외벤더", value: "isForeign", width: +80, align: "center" },
    { text: "생성일시", value: "createdAt", formatter: (date) => date?.toDateTime?.(), width: 100 },
    { text: "", value: "actions", width: +60 },
]);

export default {
    components: {
        ListHeading,
        ManufacturingVendorForm,
    },
    data: () => ({
        vendors: [],

        limit: 10,
        summary: { totalCount: 0 },

        loading: false,

        headers,
        attrs_switch,
    }),
    computed: {
        items() {
            return this.vendors.map((item, index) => ({ ...item, index: this.summary.totalCount - (this.page - 1) * this.limit - index }));
        },
        page() {
            return +(this.$route.query.page || "1");
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            let { query } = this.$route;
            return { ...query };
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        params() {
            this.search();
        },
    },
    methods: {
        async init() {
            this.vendors = [];
            this.summary = { totalCount: 0 };

            this.search();
        },

        async search() {
            if (this.loading) return;
            else this.loading = true;

            try {
                let { skip, limit, params } = this;
                var { summary, vendors } = await api.console.manufacturing.vendors.gets({
                    headers: { skip, limit },
                    params,
                });

                this.summary = summary;
                this.vendors = vendors;
            } finally {
                if (this.loading) this.loading = false;
            }
        },

        async update(item) {
            if (this.loading) return;
            else this.loading = true;

            try {
                const { vendor } = await api.console.manufacturing.vendors.put(item);
                this.loading = false;
                this.updateItem(vendor);
            } finally {
                if (this.loading) this.loading = false;
            }
        },

        updateItem(item) {
            const index = this.vendors.findIndex(({ _id }) => _id == item._id);
            if (0 <= index) this.vendors.splice(index, 1, item);
            else {
                this.summary.totalCount += 1;
                this.vendors = [item, ...this.vendors];
            }
            this.search();
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .line-height-1-5 {
        line-height: 1.5;
    }
    .max-width-0 {
        max-width: 0;
    }
    .word-break-keep-all {
        word-break: keep-all;
    }
    .white-space-pre-line {
        white-space: pre-line;
    }
    .cursor-pointer {
        cursor: pointer;
    }
    .v-pagination button {
        box-shadow: none !important;
        border: thin solid rgba(0, 0, 0, 0.12);
    }
    .v-small-dialog__activator {
        height: 100%;
    }
    .v-small-dialog__activator__content {
        width: 100%;
    }

    th:first-of-type:not(:last-of-type),
    td:first-of-type:not(:last-of-type) {
        border-right: thin solid rgba(0, 0, 0, 0.12);
    }

    .v-data-table__expanded__content {
        box-shadow: none !important;
    }
    .vertical-align-top {
        vertical-align: top !important;
    }
}
</style>
